/**
 * Reading progress bar (.bq-article__progress) for journal articles.
 * On desktop from 990px the scroller is .page-wrapper, not the root.
 */
(function () {
  function init(scope) {
    var body = scope.querySelector('[data-bq-article-body]');
    var bar = scope.querySelector('.bq-article__progress');
    if (!body || !bar || bar.dataset.bqProgressInit) return;
    bar.dataset.bqProgressInit = '1';

    var squeeze = window.matchMedia('(min-width: 990px)');
    var scroller = function () {
      return (squeeze.matches && document.querySelector('.page-wrapper')) ||
        document.scrollingElement || document.documentElement;
    };
    var scrollTarget = function () {
      return (squeeze.matches && document.querySelector('.page-wrapper')) || document;
    };
    var ticking = false;
    var bound = null;
    // The scroller outlives the section: once the bar is gone, unbind rather
    // than keep measuring a detached node.
    var release = function () {
      if (bound) bound.removeEventListener('scroll', onScroll);
      bound = null;
      squeeze.removeEventListener('change', bind);
    };
    var update = function () {
      ticking = false;
      if (!bar.isConnected) { release(); return; }
      var sc = scroller();
      var rect = body.getBoundingClientRect();
      var scTop = 0;
      if (sc !== document.scrollingElement && sc !== document.documentElement) {
        scTop = sc.getBoundingClientRect().top;
      }
      var start = sc.scrollTop + rect.top - scTop - sc.clientHeight * 0.6;
      var span = Math.max(1, rect.height - sc.clientHeight * 0.2);
      var p = Math.min(1, Math.max(0, (sc.scrollTop - start) / span));
      bar.style.setProperty('--bq-art-progress', p.toFixed(4));
    };
    var onScroll = function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    };
    function bind() {
      if (bound) bound.removeEventListener('scroll', onScroll);
      bound = scrollTarget();
      bound.addEventListener('scroll', onScroll, { passive: true });
      update();
    }
    bind();
    squeeze.addEventListener('change', bind);
  }

  init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
